import { render, staticRenderFns } from "./StepsOption.vue?vue&type=template&id=66a956d6"
import script from "./StepsOption.vue?vue&type=script&lang=js"
export * from "./StepsOption.vue?vue&type=script&lang=js"
import style0 from "./StepsOption.vue?vue&type=style&index=0&id=66a956d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports